import styled from 'styled-components'
import Image from 'next/legacy/image'
import { P } from 'common/typography'

const NoReposStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 40vh;
  .revision-icon {
    position: relative;
    height: 60px;
    width: 60px;
  }
  .send-revision {
    height: 60px;
    width: 60px;
    background-repeat: no-repeat;
    animation-duration: 1s;
    animation-delay: .8s;
    /* animation-iteration-count: 1; */
    animation-name: solicitud;
    background-image: url('/images/profile/solicitud.png');
    animation-timing-function: steps(13);
  }
  .revision-out {
    position: absolute;
    animation-name: zoomOut;
    animation-delay: 1.8s;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
  .revision-in {
    position: absolute;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    animation-name: zoomIn;
    animation-delay: 2.1s;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    opacity: 0;
  }
  @keyframes zoomOut {
    from {
      opacity: 1;
    }

    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    to {
      opacity: 0;
    }
  }
  @keyframes zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
      opacity: 1;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes solicitud {
    from { background-position: 0px; }
    to { background-position: -780px; }
  }
  p {
    margin-top: 8px;
  }
  @media(min-width: 768px) {
    height: 238px;
  }
`

function NoRepos() {
  return (
    <NoReposStyled className="no-repos">
      <div className="revision-icon">
        <div className="revision-out">
          <div className="send-revision" />
        </div>
        <div className="revision-in">
          <Image src="/images/profile/no-repos.png" alt="Icono de un repositorio" width="42.67" height="55.95" />
        </div>
      </div>
      <P align="center" fontSize="20" lineHeight="32" fontWeight="700" color="var(--neutral60)">Elige un repositorio</P>
    </NoReposStyled>
  )
}

export default NoRepos
